
import { UserModule } from '@/store/modules/user';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getInstallScourceList } from '@/api/installScource';
import OrderTag from '@/views/order/components/OrderTag.vue';
import OrderBrand from '../order/components/OrderBrand.vue';
import OrderDevice from '@/components/DeviceSelectDialog/index.vue';
import OrdertParts from '../order/components/OrderParts.vue';
import CustomerDialog from '../../components/CustomerDialog/levelByLevel.vue';
import OrderArea from '../order/components/OrderArea.vue';
import CustomerAddDialog from '../customer/components/CustomerAddDialog.vue';
import SelectDepartment from '../../components/DeptDialog/index.vue';
import OrderAddressCustom from '../order/components/OrderAddressCustom.vue';
import { addOrderServerIsHave, addOrderServerIsMust, checkPermissionCompany } from '@/utils/permission';
import { Type } from '../../types/permissionType';
import { getPriceList } from '@/api/other';
import { createOrder, getOrderInit } from '@/api/order';

@Component({
  name: 'orderinstallAplayAdd',
  components: {
    OrderBrand,
    OrderDevice,
    OrdertParts,
    CustomerDialog,
    OrderArea,
    CustomerAddDialog,
    SelectDepartment,
    OrderAddressCustom,
    OrderTag
  }
})
export default class extends Vue {
  @Watch('servicer', {
    deep: true,
    immediate: false
  })
  private servicerChange(newVal:any) {
    if (!newVal) {
      this.isShowTag = false;
      // this.isShowFaultType = false;
      this.isShowProduct = false;
      this.isShowSerDept = false;
      this.isShowAppointment = false;
      // this.isShowPic = false;
      // this.isShowSound = false;
      this.isShowAddressPca = false;
      this.isShowAddressSelf = false;
      this.isShowDevice = false;
      // this.isShowVideo = false;
      // this.isShowDiyOne = false;
      // this.isShowDiyTwo = false;
      // this.isShowWordFile = false;

      this.isShowAddress = true;
      this.isShowContentUser = true;
      this.isShowContentUserMobile = true;
      this.isShowContentUserPhone = true;
      this.isShowDescription = true;
      return;
    }
    this.serDrptOptions = newVal.dept_list;
    if (this.serDrptOptions && this.serDrptOptions.length === 1) {
      this.$set(this.formInstall, 'servicerDept', this.serDrptOptions[0]);
    }
    this.isShowSerDept = addOrderServerIsHave(Type.dept, 3, newVal);
    this.isShowTag = addOrderServerIsHave(Type.tag, 3, newVal);
    this.isShowProduct = addOrderServerIsHave(Type.product, 3, newVal);
    this.isShowDevice = addOrderServerIsHave(Type.device, 3, newVal);
    this.isShowParts = addOrderServerIsHave(Type.parts, 3, newVal);
    this.isShowRemark = addOrderServerIsHave(Type.remark, 3, newVal);
    this.isShowAppointment = addOrderServerIsHave(Type.time, 3, newVal);
    this.isShowAddressPca = addOrderServerIsHave(Type.pca, 3, newVal);
    this.isShowAddressSelf = addOrderServerIsHave(Type.myselfPCALs, 3, newVal);
    this.isShowAddress = addOrderServerIsHave(Type.address, 3, newVal);
    this.isShowContentUser = addOrderServerIsHave(Type.contentUser, 3, newVal);
    this.isShowContentUserMobile = addOrderServerIsHave(Type.contentUserMobile, 3, newVal);
    this.isShowContentUserPhone = addOrderServerIsHave(Type.contentUserPhone, 3, newVal);
    this.isShowDescription = addOrderServerIsHave(Type.Description, 3, newVal);

    this.isMustSerDept = addOrderServerIsMust(Type.dept, 3, newVal);
    this.isMustTag = addOrderServerIsMust(Type.tag, 3, newVal);
    this.isMustProduct = addOrderServerIsMust(Type.product, 3, newVal);
    this.isMustDevice = addOrderServerIsMust(Type.device, 3, newVal);
    this.isMustParts = addOrderServerIsMust(Type.parts, 3, newVal);
    this.isMustRemark = addOrderServerIsMust(Type.remark, 3, newVal);
    this.isMustAppointment = addOrderServerIsMust(Type.time, 3, newVal);
    this.isMustAddressPca = addOrderServerIsMust(Type.pca, 3, newVal);
    this.isMustAddressSelf = addOrderServerIsMust(Type.myselfPCALs, 3, newVal);
    this.isMustAddress = addOrderServerIsMust(Type.address, 3, newVal);

    this.isMustContentUser = addOrderServerIsMust(Type.contentUser, 3, newVal);
    this.isMustContentUserMobile = addOrderServerIsMust(Type.contentUserMobile, 3, newVal);
    this.isMustContentUserPhone = addOrderServerIsMust(Type.contentUserPhone, 3, newVal);
    this.isMustDescription = addOrderServerIsMust(Type.Description, 3, newVal);

    this.isShowInstallSource = addOrderServerIsHave(Type.InstallOrderSource, 3, newVal);
    this.isShowInstallNum = addOrderServerIsHave(Type.InstallOrderNum, 3, newVal);
    this.isShowInstallAppointment = addOrderServerIsHave(Type.InstallOrderAppointment, 3, newVal);

    this.isMustInstallSource = addOrderServerIsMust(Type.InstallOrderSource, 3, newVal);
    this.isMustInstallNum = addOrderServerIsMust(Type.InstallOrderNum, 3, newVal);
    this.isMustInstallAppointment = addOrderServerIsMust(Type.InstallOrderAppointment, 3, newVal);
    this.serverCompanyId = newVal.servicer_company_id
    if (this.isShowInstallSource) {
      this.getInstallScourceList();
    }
  }
  private isShowSerDept=false;
  private isMustSerDept=false;

  private isShowTag=false;
  private isMustTag=false;

  private isShowProduct=false;
  private isMustProduct=false;

  private isShowDevice=false;
  private isMustDevice=false;

  private isShowParts=false;
  private isMustParts=false;

  private isShowRemark=false;
  private isMustRemark=false;

  private isShowAppointment=false;
  private isMustAppointment=false;

  private isShowAddressPca=false;
  private isMustAddressPca=false;
  private isShowAddressSelf=false;
  private isMustAddressSelf=false;

  // 默认显示
  private isShowAddress=true;
  private isShowContentUser=true;
  private isShowContentUserMobile=true;
  private isShowContentUserPhone=true;
  private isShowDescription=true;

  private isMustAddress=false;
  private isMustContentUser=false;
  private isMustContentUserMobile=false;
  private isMustContentUserPhone=false;
  private isMustDescription=false;

  private isShowInstallSource=false;
  private isShowInstallNum=false;
  private isShowInstallAppointment=false;

  private isMustInstallSource=false;
  private isMustInstallNum=false;
  private isMustInstallAppointment=false;

  private isShowServicer=String((UserModule.getCompany as any).vip_level).substr(0, 1) !== '2'

  // 指派部门
  // private serDealDeptment=UserModule.getUserDeptList;
  // 服务部门
  // private serDeptOptions:any = []

  private formInstall:any = {
    source: '',
    ordernumberOriginal: '',
    appointmentOriginal: '',
    servicerDept: {},
    description: '',
    customer: {},
    area: '',
    address: '',
    name: '',
    mobile: '',
    phone: '',
    appointment: '',
    costRadio: '',
    brand: '',
    device: '',
    parts: '',
    remark: '',
  }

  private dynamicCost:any = [];
  private costList:any = [];

  private serverCompanyId:string=''
  private sourceOptions: any = []

  private servicer:any='';
  private serDrptOptions:any=[];
  private serListOptions:any=[];

  created() {
    this.initOrder(0);
  }
  // 初始化
  private initOrder(type:number) {
    // type 1 =报修后再次初始化 0= 进入页面初始化
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    getOrderInit(params).then(res => {
      if (res.data) {
        if (res.data.servicer_list && res.data.servicer_list.length === 1) {
          this.servicer = res.data.servicer_list[0];
          this.serDrptOptions = res.data.servicer_list[0].dept_list;
          if (this.serDrptOptions && this.serDrptOptions.length === 1) {
            if (type === 0) {
              this.$set(this.formInstall, 'servicerDept', this.serDrptOptions[0]);
            } else {
              if (!this.formInstall.servicerDept || !this.formInstall.servicerDept.dept_id) {
                this.$set(this.formInstall, 'servicerDept', this.serDrptOptions[0]);
              }
            }
          }
        }
        this.serListOptions = res.data.servicer_list;
        if (res.data.address_default) {
          if (res.data.address_default.province_name) {
            this.$set(this.formInstall, 'area', res.data.address_default.province_name !== res.data.address_default.city_name
              ? res.data.address_default.province_name + '  ' + res.data.address_default.city_name + '  ' + res.data.address_default.district_name
              : res.data.address_default.province_name + '  ' + res.data.address_default.district_name);
          }
          this.provinceName = res.data.address_default.province_name;
          this.province = res.data.address_default.province;
          this.cityName = res.data.address_default.city_name;
          this.city = res.data.address_default.city;
          this.districtName = res.data.address_default.district_name;
          this.district = res.data.address_default.district;
          this.$set(this.formInstall, 'address', res.data.address_default.address);
          this.$set(this.formInstall, 'name', res.data.address_default.name);
          this.$set(this.formInstall, 'mobile', res.data.address_default.mobile);
          this.$set(this.formInstall, 'phone_num', res.data.address_default.phone_num);
        }
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private placeHolderDescription:string= '任务描述';
  // 订单标签
  private selectTagArray:any = []
  private tagVisible = false
  private selectTag() {
    if (this.servicer) {
      if (this.selectTagArray && this.selectTagArray.length >= 3) {
        this.showErrorMsg('最多只能选择3个标签');
        return;
      }
      this.tagVisible = true;
    } else {
      this.showErrorMsg('请选择服务方');
    }
  }
  private closeTagHandle(value:boolean) {
    this.tagVisible = value;
  }
  private delTagHandle(val: any) {
    this.selectTagArray.splice(this.selectTagArray.indexOf(val), 1);
  }
  private confirmTagHandle(value:any) {
    this.tagVisible = false;
    let filter = this.selectTagArray.filter((tag:any) => {
      return tag.tags_id === value.tags_id;
    });
    if (filter && filter.length > 0) {
      return;
    }
    this.selectTagArray.push(value);
    let descriptionPlaceholdera = '';
    if (this.selectTagArray && this.selectTagArray.length > 0) {
      for (let i = 0; i < this.selectTagArray.length; i++) {
        if (this.selectTagArray[i].trouble_describle_prompt) {
          descriptionPlaceholdera += (this.selectTagArray[i].trouble_describle_prompt + ';');
        }
      }
    }
    if (descriptionPlaceholdera && descriptionPlaceholdera.length > 0) {
      this.placeHolderDescription = descriptionPlaceholdera.slice(0, descriptionPlaceholdera.length - 1);
    }
  }
  // 选择部门
  // getDeptList() {
  //   const params = {
  //     user_id: UserModule.getUserId,
  //     company_id: UserModule.getCompanyId,
  //     type: 8,
  //     dept_type: 2,
  //     page: 1
  //   };
  //   getDepartmentList(params).then(res => {
  //     if (res.data) {
  //       this.serDeptOptions = res.data.list;
  //     } else {
  //       this.serDeptOptions = [];
  //     }
  //   }).catch(err => {
  //     this.showErrorMsg(err.msg);
  //   });
  // }

  private departmentVisible = false
  private title = '选择部门'

  private selectDeptServicerHandle() {
    this.departmentVisible = true;
  }
  private selectDept(val:any) {
    this.formInstall.servicerDept = val;
  }
  private closeDeptHandle(value: boolean) {
    this.departmentVisible = value;
  }
  // 任务描述
  private dynamicDescription:any[] = []
  private descriptionAddHandle() {
    if (this.dynamicDescription && this.dynamicDescription.length > 3) {
      this.$alert('最多添加5条任务描述', '提示', {
        confirmButtonText: '确定'
      });
    } else {
      this.dynamicDescription.push({
        value: ''
      });
    }
  }
  private descriptionDeleteHandle(value: any) {
    // 删除新增的任务描述
    let index = this.dynamicDescription.indexOf(value);
    if (index !== -1) {
      this.dynamicDescription.splice(index, 1);
    }
  }
  // 选择省市区
  private areaVisible = false
  private provinceName=''
  private province=''
  private cityName=''
  private city=''
  private districtName=''
  private district=''
  private adcode=''
  private selectAreaHandle() {
    if (this.isShowAddressPca) {
      this.areaVisible = true;
    } else if (this.isShowAddressSelf) {
      this.areaCustomVisible = true;
    }
  }
  private closeAreaHandle(value:boolean) {
    this.areaVisible = value;
  }
  private saveAreaHandle(value:any) {
    this.adcode = '';
    this.provinceName = value.provinceName;
    this.province = value.province;
    this.cityName = value.cityName;
    this.city = value.city;
    this.districtName = value.districtName;
    this.district = value.district;
    this.formInstall.area = value.province_name !== value.city_name
      ? value.province_name + '  ' + value.city_name + '  ' + value.district_name
      : value.province_name + '  ' + value.district_name;
    this.areaVisible = false;
  }
  // 选择自定义
  private areaCustomVisible = false
  private oneAddress=''
  private oneAddressId=''
  private twoAddress=''
  private twoAddressId=''
  private threeAddress=''
  private threeAddressId=''
  private saveAreaCustomHandle(value:any) {
    this.areaCustomVisible = false;
    if (value) {
      if (value.pBean && value.pBean1) {
        this.oneAddress = JSON.parse(value.pBean).address;
        this.oneAddressId = JSON.parse(value.pBean).id;
        this.twoAddress = JSON.parse(value.pBean1).address;
        this.twoAddressId = JSON.parse(value.pBean1).id;
        this.threeAddress = value.address;
        this.threeAddressId = value.id;
      } else if (value.pBean) {
        this.oneAddress = JSON.parse(value.pBean).address;
        this.oneAddressId = JSON.parse(value.pBean).id;
        this.twoAddress = value.address;
        this.twoAddressId = value.id;
        this.threeAddress = '';
        this.threeAddressId = '0';
      } else {
        this.oneAddress = value.address;
        this.oneAddressId = value.id;
        this.twoAddress = '';
        this.twoAddressId = '0';
        this.threeAddress = '';
        this.threeAddressId = '0';
      }
    }
    this.formInstall.area = this.oneAddress + '  ' + this.twoAddress + '  ' + this.threeAddress;
  }
  private closeAreaCustomHandle(value:boolean) {
    this.areaCustomVisible = value;
  }
  // 原始预约时间
  private appointmentOriginalDayTimestamp:any=''
  private pickerOriginalChange(val:any) {
    if (!val) {
      this.appointmentOriginalDayTimestamp = ''
      return
    }
    let minite = val.slice(-2);
    let hour = val.slice(-5, -3);
    val = val.slice(0, -5);
    let minite2 = '00';
    let i = Math.ceil(parseInt(minite) / 5);
    if (i * 5 < 10) {
      minite2 = '0' + i * 5;
    } else {
      minite2 = '' + i * 5;
    }
    val = val + hour + ':' + minite2;
    let ieval = val.replace(/-/g, '/');
    let data = new Date(ieval);
    this.appointmentOriginalDayTimestamp = data.getTime() / 1000;
    this.formInstall.appointmentOriginal = val;
  }
  // 预约时间
  private appointmentDayTimestamp:any=''
  private pickerChange(val:any) {
    if (!val) {
      this.appointmentDayTimestamp = ''
      return
    }
    let minite = val.slice(-2);
    let hour = val.slice(-5, -3);
    val = val.slice(0, -5);
    let minite2 = '00';
    let i = Math.ceil(parseInt(minite) / 5);
    if (i * 5 < 10) {
      minite2 = '0' + i * 5;
    } else {
      minite2 = '' + i * 5;
    }
    val = val + hour + ':' + minite2;
    let ieval = val.replace(/-/g, '/');
    let data = new Date(ieval);
    this.appointmentDayTimestamp = data.getTime() / 1000;
    this.formInstall.appointment = val;
  }
  // 费用
  private getPriceList() {
    let parameters:any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = this.serverCompanyId;
    getPriceList(parameters).then(res => {
      if (res.data) {
        this.costList = res.data.list;
      } else {
        this.costList = [];
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private priceChange(price:any) {
    this.$set(this.formInstall, 'costValue', price.price_num);
  }
  private priceNewChange(index:number, price:any) {
    this.$set(this.dynamicCost[index], 'value', price.price_num);
  }
  // 添加费用
  private addCostHandle() {
    this.dynamicCost.push({
      type: '',
      value: ''
    });
  }
  private removeCostHandle(v:any) {
    let index = this.dynamicCost.indexOf(v);
    if (index !== -1) {
      this.dynamicCost.splice(index, 1);
    }
  }
  // 选择品牌
  private brandVisible = false;
  private productBeanList:any = []
  private selectBrandHandle() {
    if (this.productBeanList && this.productBeanList.length >= 5) {
      this.showErrorMsg('最多只能添加5个品牌');
      return;
    }
    this.brandVisible = true;
  }

  private confirmBrandHandle(val:any) {
    this.productBeanList.push(val);
  }
  private cleanProduct(val:any, index:any) {
    this.productBeanList.splice(index, 1);
  }
  private closeBrandHandle(value: boolean) {
    this.brandVisible = value;
  }

  // 设备
  private deviceVisible = false
  private selectDevice:any = []
  private selectDeviceHandle() {
    if (this.selectDevice.length >= 5) {
      this.showErrorMsg('最多只能选择5个设备');
      return;
    }
    this.deviceVisible = true;
  }

  private confirmDeviceHandle(value: any) {
    if (this.selectDevice && this.selectDevice.length < 1) {
      this.selectDevice = value;
    } else {
      this.selectDevice = this.selectDevice.concat(value);
    }
  }
  private cleanDevice(val:any, index:any) {
    this.selectDevice.splice(index, 1);
  }
  private closeDeviceHandle(value: boolean) {
    this.deviceVisible = value;
  }

  // 物品
  private partsVisible = false;
  private companyId = '';
  private selectParts:any=[];
  private selectPartsHandle() {
    this.partsVisible = true;
    this.companyId = UserModule.getCompanyId;
  }
  private confirmPartsHandle(val:any) {
    this.selectParts.push(val);
  }
  private cleanPart(val:any, index:any) {
    this.selectParts.splice(index, 1);
  }
  private closeParts(val:boolean) {
    this.partsVisible = val;
  }
  // 立即添加
  private submit() {
    var parameters:any = {};
    // 1是自己报，2是替客户报
    parameters['order_create_type'] = '1';
    parameters['order_type'] = '3';
    // parameters['address_type'] = this.addrssType;

    parameters['user_id'] = UserModule.getUserId;
    parameters['user_name'] = UserModule.getUserName;
    // TODO 缺个人身份报修

    if (UserModule.getCompanyId && parseInt(UserModule.getCompanyId) !== 0) {
      parameters['company_id'] = UserModule.getCompanyId;
      parameters['customer_company_id'] = UserModule.getCompanyId;
      parameters['customer_company_name'] = UserModule.getCompanyName;
      if (this.formInstall.userDept && this.formInstall.userDept.dept_id) {
        parameters['customer_dept_name'] = this.formInstall.userDept.name;
        parameters['customer_dept_id'] = this.formInstall.userDept.dept_id;
      }
    } else {
      parameters['company_id'] = UserModule.getCompanyId;
      parameters['customer_user_id'] = UserModule.getUserId;
      parameters['customer_user_name'] = UserModule.getUserName;
    }
    if (!this.servicer || !this.servicer.servicer_company_id) {
      this.showErrorMsg('请选择服务方');
      return;
    }
    parameters['servicer_company_id'] = this.servicer.servicer_company_id;
    parameters['servicer_company_name'] = this.servicer.name;

    if (!(this.selectTagArray && this.selectTagArray.length > 0) && this.isMustTag) {
      this.showErrorMsg('请添加标签');
      return;
    }
    if (this.selectTagArray && this.selectTagArray.length > 0) {
      let array:any = [];
      for (let i = 0; i < this.selectTagArray.length; i++) {
        let item = this.selectTagArray[i];
        let dic = {
          'tags_name': item.tags_name,
          'tags_id': item.tags_id
        };
        array.push(dic);
      }
      parameters['tags'] = JSON.stringify(array);
    }
    // 订单来源三选
    if (!(this.formInstall.servicerDept && this.formInstall.servicerDept.dept_id) && this.isMustSerDept) {
      this.showErrorMsg('请选择服务部门');
      return;
    }
    if (this.formInstall.servicerDept) {
      if(this.isShowSerDept){
        parameters['servicer_dept_id'] = this.formInstall.servicerDept.dept_id;
        parameters['servicer_dept_name'] = this.formInstall.servicerDept.name;
      }
    }
    // 订单来源三选
    if (!(this.formInstall.source && this.formInstall.source.id) && this.isMustInstallSource) {
      this.showErrorMsg('请选择订单来源');
      return;
    }
    if (this.formInstall.source && this.formInstall.source.id) {
      parameters['install_source_id'] = this.formInstall.source.id;
      parameters['install_source_name'] = this.formInstall.source.name;
    }
    if (!this.formInstall.ordernumberOriginal && this.isMustInstallNum) {
      this.showErrorMsg('请输入订单原始单号');
      return;
    }
    if (this.formInstall.ordernumberOriginal) {
      parameters['order_original_num'] = this.formInstall.ordernumberOriginal;
    }
    if (!this.appointmentOriginalDayTimestamp && this.isMustInstallAppointment) {
      this.showErrorMsg('请选择原始预约时间');
      return;
    }
    if (this.appointmentOriginalDayTimestamp) {
      parameters['original_appointment_time'] = this.appointmentOriginalDayTimestamp;
    }
    let troubleDes = '';
    let num = 0;
    if (this.formInstall.description) {
      num = num + 1;
      troubleDes = num + '、' + this.formInstall.description + ';';
    }
    this.dynamicDescription.forEach(des => {
      if (des.value) {
        num = num + 1;
        troubleDes = troubleDes + num + '、' + des.value + ';';
      }
    });

    if (!(troubleDes && troubleDes.length > 0) && this.isMustDescription) {
      this.showErrorMsg('请输入' + this.placeHolderDescription);
      return;
    }
    
    parameters['trouble_describle'] = troubleDes;

    if (!this.formInstall.area && this.isMustAddressPca) {
      this.showErrorMsg('请选择省市区');
      return;
    }
    if (!this.formInstall.area && this.isMustAddressSelf) {
      this.showErrorMsg('请选择所在地区');
      return;
    }
    if (!this.formInstall.address && this.isMustAddress) {
      this.showErrorMsg('请输入地址');
      return;
    }
    if (this.isShowAddressPca) {
      parameters['province_name'] = this.provinceName;
      parameters['city_name'] = this.cityName;
      parameters['district_name'] = this.districtName;
      parameters['province'] = this.province;
      parameters['city'] = this.city;
      parameters['district'] = this.district;
    }
    if (this.isShowAddressSelf) {
      parameters['address_type'] = 3;
      parameters['one_address_id'] = this.oneAddressId;
      parameters['one_address_name'] = this.oneAddress;
      parameters['two_address_id'] = this.twoAddressId;
      parameters['two_address_name'] = this.twoAddress;
      parameters['three_address_id'] = this.threeAddressId;
      parameters['three_address_name'] = this.threeAddress;
    }
    if (this.isShowAddress) {
      parameters['address'] = this.formInstall.address;
    }

    if (this.adcode) {
      parameters['adcode'] = this.adcode;
    }

    if (!this.formInstall.name && this.isMustContentUser) {
      this.showErrorMsg('请输入联系人姓名');
      return;
    }
    if (this.formInstall.name) {
      if (this.formInstall.name.length < 2 && this.formInstall.name.length > 10) {
        this.showErrorMsg('请输入2-10位联系人姓名');
        return;
      }
    }
    if (this.isShowContentUser) {
      parameters['name'] = this.formInstall.name;
    }

    if (!(this.formInstall.mobile && this.formInstall.mobile.length > 0) && this.isMustContentUserMobile) {
      this.showErrorMsg('请输入手机号码');
      return;
    }
    if (this.formInstall.mobile && this.formInstall.mobile.length > 0) {
      if (!(this.formInstall.mobile.charAt(0) === '1' && this.formInstall.mobile.length === 11)) {
        this.showErrorMsg('请输入正确的手机号码');
        return;
      }
      if (this.isShowContentUserMobile) {
        parameters['mobile'] = this.formInstall.mobile;
      }
    }
    if (!(this.formInstall.phone && this.formInstall.phone.length > 0) && this.isMustContentUserPhone) {
      this.showErrorMsg('请输入联系电话');
      return;
    }
    if (this.formInstall.phone && this.formInstall.phone.length > 0) {
      if (!(this.formInstall.phone.length >= 3 && this.formInstall.phone.length <= 18)) {
        this.showErrorMsg('请输入3-18位联系电话,支持输入"-"、" _"');
        return;
      }
      if (this.isShowContentUserPhone) {
        parameters['phone_num'] = this.formInstall.phone;
      }
    }
    if (!this.isMustContentUserPhone && !this.isMustContentUserMobile && this.isShowContentUserMobile && this.isShowContentUserPhone &&
    !(this.formInstall.mobile && this.formInstall.mobile.length > 0) && !(this.formInstall.phone && this.formInstall.phone.length > 0)) {
      this.showErrorMsg('请输入手机号码 或 3-18位联系电话,支持输入"-"、" _"');
      return;
    }

    if (!this.formInstall.appointment && this.isMustAppointment && !this.appointmentDayTimestamp) {
      this.showErrorMsg('请选择服务预约时间');
      return;
    }

    parameters['servicer_appointment_time'] = this.appointmentDayTimestamp;

    // 收费
    // if (!this.formInstall.costRadio) {
    //   this.showErrorMsg('请选择是否收费');
    //   return;
    // }
    // parameters['is_charge'] = this.formInstall.costRadio;

    if ((!this.productBeanList || this.productBeanList.length < 1) && this.isMustProduct) {
      this.showErrorMsg('请添加品牌类型');
      return;
    }
    if (this.productBeanList && this.productBeanList.length > 0) {
      var str = JSON.stringify(this.productBeanList);
      parameters['product'] = str;
    }

    if (!(this.selectDevice && this.selectDevice.length > 0) && this.isMustDevice) {
      this.showErrorMsg('请添加设备');
      return;
    }
    if (this.selectDevice && this.selectDevice.length > 0) {
      var arrayDevice:any = [];
      this.selectDevice.forEach((device:any) => {
        var dic = {
          'device_id': device.id
        };
        arrayDevice.push(dic);
      });
      var strDevice = JSON.stringify(arrayDevice);
      parameters['device'] = strDevice;
    }

    if (!(this.selectParts && this.selectParts.length > 0) && this.isMustParts) {
      this.showErrorMsg('请添加物品');
      return;
    }
    if (this.selectParts && this.selectParts.length > 0) {
      var strParts = JSON.stringify(this.selectParts);
      parameters['parts'] = strParts;
    }

    if (!this.formInstall.remark && this.isMustRemark) {
      this.showErrorMsg('请添加备注');
      return;
    }
    if (this.formInstall.remark) {
      let remarkList:any = [];
      remarkList.push(this.formInstall.remark);
      var remark = JSON.stringify(remarkList);
      parameters['remark'] = remark;
    }

    // if (this.formInstall.isSelf && (this.formInstall && this.formInstall.sendDept.length > 0) &&
    // (!this.formInstall.sendDept || !this.formInstall.sendDept.dept_id)) {
    //   this.showErrorMsg('请选择自己的部门');
    //   return;
    // }
    // parameters['allot_dept_state'] = this.formInstall.isSelf ? 1 : 0;
    // if (this.formInstall.sendDept) {
    //   parameters['allot_dept_id'] = this.formInstall.sendDept.dept_id;
    //   parameters['allot_dept_name'] = this.formInstall.sendDept.name;
    // }
    // let costList:any = [];
    // if (this.formInstall.costType && this.formInstall.costType.id) {
    //   let cost:any = {};
    //   cost.price_id = this.formInstall.costType.id;
    //   cost.price_name = this.formInstall.costType.price_name;
    //   cost.price_num = this.formInstall.costValue;
    //   costList.push(cost);
    // }
    // if (this.dynamicCost && this.dynamicCost.length > 0) {
    //   for (var cost of this.dynamicCost) {
    //     if (cost.type && cost.type.id) {
    //       let costs:any = {};
    //       costs.price_id = cost.type.id;
    //       costs.price_name = cost.type.price_name;
    //       costs.price_num = cost.value;
    //       costList.push(costs);
    //     }
    //   }
    // }
    // if (!(costList && costList.length > 0) && this.isMustPrice) {
    //   this.showErrorMsg('请添加费用');
    //   return;
    // }
    // if (costList && costList.length > 0) {
    //   var strCostList = JSON.stringify(costList);
    //   parameters['price'] = strCostList;
    // }
    createOrder(parameters).then(res => {
      let _this = this;
      this.showSecussMsg((res as any).msg);
      this.rest(1);
    }).catch(error => {
      if(error.code === 405221){
        const _this = this
        this.$confirm(error.msg, '提示', {
          confirmButtonText: '去验收',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.$router.push({
            path: '/order/unconfirmed',
          });
        }).catch(() => {
              
        });
        return;
      }
      this.showErrorMsg(error.msg);
    });
  }
  private rest(type:number) {
    if (type === 1) {
      this.initOrder(type);
      this.serDrptOptions = [];
      this.selectTagArray = [];
      this.appointmentOriginalDayTimestamp = '';
      this.appointmentDayTimestamp = '';
      this.productBeanList = [];
      this.selectDevice = [];
      this.selectParts = [];
      this.dynamicDescription = [];
      this.adcode = '';
      this.provinceName = '';
      this.province = '';
      this.cityName = '';
      this.city = '';
      this.districtName = '';
      this.district = '';
      this.formInstall = {
        tag: '',
        source: '',
        ordernumberOriginal: '',
        appointmentOriginal: '',
        servicerDept: {},
        description: '',
        customer: {},
        area: '',
        address: '',
        name: '',
        mobile: '',
        phone: '',
        appointment: '',
        brand: '',
        device: '',
        parts: '',
        remark: '',
      }
    } else {
      this.initOrder(type);
      this.serDrptOptions = [];
      this.selectTagArray = [];
      this.productBeanList = [];
      this.selectDevice = [];
      this.selectParts = [];
      this.adcode = '';
      this.provinceName = '';
      this.province = '';
      this.cityName = '';
      this.city = '';
      this.districtName = '';
      this.district = '';
      this.formInstall.tag = ''
      this.formInstall.source = ''
      this.formInstall.servicerDept = {}
      this.formInstall.customer = {}
      this.formInstall.area = ''
      this.formInstall.brand = ''
      this.formInstall.device = ''
      this.formInstall.parts = ''
      this.formInstall.remark = ''
    }
  }
private pagination: any = {
  currentPage: 1,
  pageSize: 10,
  total: 0
}
private getInstallScourceList() {
  let paramters:any = {};
  paramters.user_id = UserModule.getUserId;
  paramters.company_id = this.serverCompanyId;
  paramters.page = this.pagination.currentPage;
  paramters.size = 9999;

  getInstallScourceList(paramters).then(res => {
    if (res.data) {
      this.sourceOptions = res.data.list;
      this.pagination.total = parseInt(res.data.count);
    } else {
      this.sourceOptions = [];
    }
  }).catch(err => {
    let msg = err.msg;
    this.sourceOptions = [];
    this.pagination.total = 0;
    this.pagination.currentPage = 1;
  });
}
private showErrorMsg(msg: string) {
  this.$notify({
    title: '提示',
    message: msg,
    offset: 100,
    type: 'error'
  });
}
private showSecussMsg(msg: string) {
  this.$notify({
    title: '提示',
    message: msg,
    offset: 100,
    type: 'success'
  });
}
}
